import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/Notifications';


import styles from './styles';
import { getAuthUser } from '../../redux/actions/authActions';

class Header extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      user: null
    }
  }

  componentWillMount() {

    this.setState({ user: getAuthUser() })

  }


  render() {

    const { classes, open, toggleDrawer } = this.props;
    const { user } = this.state;

    return (
      <div>


        {user && user.context
          && (
            <AppBar
              position="absolute"
              className={classNames(classes.appBar, open && classes.appBarShift)}
            >
              <Toolbar disableGutters={!open} className={classes.toolbar}>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={toggleDrawer}
                  className={classNames(
                    classes.menuButton,
                    open && classes.menuButtonHidden,
                  )}
                >
                  <MenuIcon />
                </IconButton>
                <Typography
                  component="h1"
                  variant="h6"
                  color="inherit"
                  noWrap
                  className={classes.title}
                >
                  {user.Name}
                  {' '}
                  -
              {' '}
                  {user.context.name}
                </Typography>
                {/* <IconButton color="inherit">
        <Badge badgeContent={4} color="secondary">
        <NotificationsIcon />
        </Badge>
      </IconButton> */}
              </Toolbar>
            </AppBar>
          )
        }
      </div>
    );

  }
}


Header.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDrawer: PropTypes.func,
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/dashboard/Header.js